module.exports = __webpack_public_path__ + "img/icon2.6a815347.png";